// extracted by mini-css-extract-plugin
module.exports = {"problems-poster-first-word":"Problems_problems-poster-first-word_sY9Kc"};